import { defineNuxtRouteMiddleware, navigateTo, useNuxtApp, useRuntimeConfig } from '#app'
import { useAuthStore } from '~/stores/useAuthStore'

export default defineNuxtRouteMiddleware((to) => {
  // Don't redirect on auth route
  if (to.path.includes('/auth')) {
    return
  }

  const nuxtApp = useNuxtApp()

  if (!to.path.includes('/error') && !to.path.includes('/unauthorised')) {
    nuxtApp.$auth.setHistory(to.path)
  }

  const active = useAuthStore(nuxtApp.$pinia).active

  // Redirect if no active user
  if (!active) {
    // If stored accounts exist redirect to switch
    if (nuxtApp.$auth.accountIDs.length) {
      return navigateTo(`/auth/switch?redirect=${to.path}`)
    }

    const config = useRuntimeConfig()
    if (config.public.instance === 'demo') {
      if (to.path.includes('/demo')) {
        return
      }
      return navigateTo('/demo')
    }

    return navigateTo(`/auth/login/email?redirect=${to.path}`)
  }

  // Check if user has required grants / features / gates before navigation.
  // Each plugin exposes `.all()` that returns true when the user satisfies the
  // requirement (and short-circuits to false on missing auth state). An
  // unauthorised redirect is the same regardless of which check failed.
  const meta = to.meta as { grants?: Record<string, string[]>; features?: string[]; gates?: string[] }
  if (meta?.grants && !nuxtApp.$grants.all(meta.grants)) {
    return navigateTo('/unauthorised')
  }
  if (meta?.features && !nuxtApp.$features.all(meta.features)) {
    return navigateTo('/unauthorised')
  }
  if (meta?.gates && !nuxtApp.$gates.all(meta.gates)) {
    return navigateTo('/unauthorised')
  }
})
